export const CalloutRule = {
    "HangUpManualDial":"HangUpManualDial",
    "GetAgentID":"GetAgentID",
    "GetUserName":"getUserName",
    "GetExtension":"GetExtension",
};


// WEBPACK FOOTER //
// ./src/BusinessRule/CalloutRule.js